export default __webpack_public_path__ + "static/media/Labs_Symbol_01-01.49d8afba.svg";